import type { Booking } from "../types/booking";

/** Post export license fee when set to a positive amount. */
export const getPostExportLicenseFee = (
  booking: Pick<Booking, "post_export_license">
): number | null => {
  const fee = booking.post_export_license;
  if (fee == null || fee <= 0) return null;
  return fee;
};

export const hasPostExportLicenseFee = (
  booking: Pick<Booking, "post_export_license">
): boolean => getPostExportLicenseFee(booking) != null;
